var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        "destroy-on-close": "",
        "before-close": function (done) {
          return done()
        },
        title: _vm.$t("pc_kng_lbl_selectkng"),
        visible: _vm.visible,
        size: "960px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("yxtbiz-select-newkng", {
        attrs: { max: _vm.selectableLength },
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("pc_kng_common_btn_cancel")))]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("pc_kng_common_btn_confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }